import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import usePreferences from 'hooks/usePreferences';
import React from 'react';
import AnnouncementsBanner from 'shared/components/AnnouncementsBanner';
import { Announcement } from 'shared/types';

const GET_ANNOUNCEMENTS = gql`
  query GetAnnouncements($lastAnnouncementDate: String) {
    announcements(lastDate: $lastAnnouncementDate) {
      id
      content
      insertedAt
    }
  }
`;

const AnnouncementsModal = () => {
  const { lastAnnouncementDate, setLastAnnouncementDate } = usePreferences();
  const { data } = useQuery<{ announcements: Announcement[] }>(
    GET_ANNOUNCEMENTS,
    {
      fetchPolicy: 'cache-and-network',
      variables: { lastAnnouncementDate },
    }
  );

  return (
    <AnnouncementsBanner
      announcements={(data && data.announcements) || []}
      setLastAnnouncementDate={setLastAnnouncementDate}
    />
  );
};

export default AnnouncementsModal;
